import React, { useEffect, useState } from "react";
import { Typography, Box, Divider } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import GlobalModal from "../../../components/modalBox";
import AdminApi from "../../../config/apis/admin";
import { api, resolveUrl } from "../../../config/apis";
// import styles from "../broadcast/styles.module.css"; // reuse modal styles if needed

export const ViewFriendDetails = ({ viewId, modalOpen, setModalOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  const [friendData, setFriendData] = useState(null);

  const handleCloseModal = () => {
    setModalOpen(false);
    queryParams.delete("id");
    navigate({ pathname: location.pathname, search: queryParams.toString() });
    setFriendData(null);
  };

  useEffect(() => {
    if (viewId && modalOpen) {
      const fetchFriendDetails = async () => {
        try {
          const response = await api.get(
            resolveUrl(AdminApi.FRIENDS_OF_CG_DETAILS, viewId)
          );
          setFriendData(response.data.data);
        } catch (error) {
          console.error("Error fetching friend details:", error);
        }
      };

      fetchFriendDetails();
    }
  }, [viewId, modalOpen]);

  return (
    <GlobalModal
      open={modalOpen}
      onClose={handleCloseModal}
      width={500}
      padding="20px"
    >
      {friendData && (
  <Box>
    <Typography fontSize={16} fontWeight="bold">
      {friendData.organization}
    </Typography>
    <Divider sx={{ my: 1 }} />

    <Box mb={1.5}>
      <Typography fontSize={16} fontWeight="bold">Type</Typography>
      <Typography fontSize={15} fontWeight={400}>
        {friendData.partner_type}
      </Typography>
    </Box>

    <Box mb={1.5}>
      <Typography fontSize={16} fontWeight="bold">Category</Typography>
      <Typography fontSize={15} fontWeight={400}>
        {friendData.partner_placement}
      </Typography>
    </Box>

    <Box mb={1.5}>
      <Typography fontSize={16} fontWeight="bold">Website</Typography>
      <Typography fontSize={15} fontWeight={400}>
        {friendData.website_url ? friendData.website_url : '-'}
      </Typography>
    </Box>

    <Box mb={1.5}>
      <Typography fontSize={16} fontWeight="bold">Contact Person</Typography>
      <Typography fontSize={15} fontWeight={400}>
        {friendData.contact_person ? friendData.contact_person : '-'}
      </Typography>
    </Box>

    <Box mb={1.5}>
      <Typography fontSize={16} fontWeight="bold">Email</Typography>
      <Typography fontSize={15} fontWeight={400}>
        {friendData.email ? friendData.email : '-'}
      </Typography>
    </Box>

    <Box mb={1.5}>
      <Typography fontSize={16} fontWeight="bold">Last Interaction</Typography>
      <Typography fontSize={15} fontWeight={400}>
        {friendData.last_interaction}
      </Typography>
    </Box>

    <Box mb={1.5}>
      <Typography fontSize={16} fontWeight="bold">Status</Typography>
      <Typography fontSize={15} fontWeight={400}>
        {friendData.status === 1 ? 'Active' : 'Inactive'}
      </Typography>
    </Box>

    <Box mb={1.5}>
      <Typography fontSize={16} fontWeight="bold">Comments</Typography>
      <Typography fontSize={15} fontWeight={400}>
        {friendData.comment ? friendData.comment : '-'}
      </Typography>
    </Box>
  </Box>
)}

    </GlobalModal>
  );
};
